/**
 * @author Ketan Shetye
 * @created 2025-10-25
 * @description common checkbox component
 */
import {
  Component,
  Input,
  Optional,
  Self,
  ViewEncapsulation
} from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import { CommonCheckboxData } from './common-checkbox.component.model';

@Component({
  selector: 'wm-common-checkbox',
  standalone: false,
  templateUrl: './common-checkbox.component.html',
  styleUrls: ['./common-checkbox.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CommonCheckboxComponent implements ControlValueAccessor {

  private _data: CommonCheckboxData = {
    label: '',
    checked: false,
    disabled: false,
    fontSize: '16px',
    fontFamily: 'Nunito Sans',
    fontWeight: '500',
    required: false,
    name: 'checkbox',
    helperText: '',
    className: ''
  };

  @Input({ required: true })
  set data(value: CommonCheckboxData) {
    this._data = { ...this._data, ...value };
  }

  get data(): CommonCheckboxData {
    return this._data;
  }

  disabled = false;

  constructor(@Optional() @Self() public ngControl: NgControl) {
    if (this.ngControl) {
      this.ngControl.valueAccessor = this;
    }
  }

  onChange = (_: boolean) => {};
  onTouched = () => {};

  writeValue(value: boolean): void {
    this._data.checked = !!value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

 get hasValidationError(): boolean {
  if (!this.ngControl) return false;

  const control = this.ngControl.control;
  if (!control) return false;

  const interacted = control.touched || control.dirty;
  if (!interacted) return false;

  const parent = control.parent;
  if (parent && (parent.touched || parent.dirty)) {
    if (parent.valid) return false;
    if (parent.errors) return true;
  }

  if (this.data.required && !this.data.checked) return true;


  return control.invalid;
}


  onCheckboxChange(event: Event): void {
  const checked = (event.target as HTMLInputElement).checked;
  this._data.checked = checked;
  this.onChange(checked);
  this.onTouched();

  this.ngControl?.control?.parent?.markAsTouched();
  this.ngControl?.control?.parent?.updateValueAndValidity();
}
}
